import { render, staticRenderFns } from "./FinanceModuleContent.vue?vue&type=template&id=37f4d763&scoped=true"
import script from "./FinanceModuleContent.vue?vue&type=script&lang=js"
export * from "./FinanceModuleContent.vue?vue&type=script&lang=js"
import style0 from "./FinanceModuleContent.vue?vue&type=style&index=0&id=37f4d763&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f4d763",
  null
  
)

export default component.exports